import { createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";

interface ToggleEnrollmentBalanceBypassCommand {
  enrollmentId: string;
  enabled: boolean;
}

export const toggleEnrollmentBalanceBypass = createAsyncThunk<void, ToggleEnrollmentBalanceBypassCommand, { extra: Partial<Dependencies> }>(
  "admin/toggleEnrollmentBalanceBypass",
  async ({ enrollmentId, enabled }: ToggleEnrollmentBalanceBypassCommand, { extra: { adminRepository } }) => {
    return adminRepository!.setEnrollmentBalanceBypass(enrollmentId, enabled);
  },
);
